exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.news-content[data-v-143e9d6a] {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.scrolling-text[data-v-143e9d6a] {\n  display: inline-block;\n  white-space: nowrap;\n}\n", ""]);

// exports
